<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<div class="title">
			<div id="notice">
				<h5>车辆资产盘点单&nbsp;&nbsp;说明:</h5><br>
				<span>1、盘点期间,对应仓库不能操作库存。盘点数量为最终实时库存数量。</span><br>
				<span class="red">2、盘点结果是多少,实时库存就是多少。</span><br>
				<span class="red">3、用于整体仓库数量批量修改</span><br>
				<span>4、查询关键字:盘点单号、仓库名称</span><br>
				<!-- <span>查询:标题</span><br> -->
			</div>
		</div>
		<div v-show="show_table" class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<button @click="look_note">备注说明</button>
					<!-- <button @click="edit_mode">引入模板</button> -->
				</div>
			</div>
		</div>

		<!-- 动态查询区生成 -->
		<div v-show="show_table" class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->
				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>

			</div>

		</div>
		<div class="content_edit" v-show="file_show && show_table ">
			<div class="content_edit_item">
				<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
			</div>
		</div>

		<pre-table v-show="show_table" ref="file_table" @tab-event="refresh_data" :api_url="load_url"
			:pre_post="load_json" :pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
					<th class="short0 cen">编辑</th>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'m_' + user.item[1].val" @click="sel_row(user.item,'edit')"
					@dblclick="sel_row(user.item,'show')">
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='img_url'">
							<el-image style="width: 20px; height: 20px" :src="check_url(d.val)"
								:preview-src-list="[check_url(d.val)]">
							</el-image>
						</div>
						<div v-else-if="d.key=='f_web_url'">
							<a :href="d.val" target="_blank">外链</a>
						</div>
						<div v-else>{{d.val}}</div>
					</td>
					<td class="short0 cen">
						<button @click="sel_row(user.item,'show')">编辑</button>
						<button @click="fun_del(user.item,'del')">删除</button>
					</td>
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">




			</template>
		</pre-table>

		<!-- 弹出向导层 start-->
		<pretan ref="mypop">
			<template slot="tancontent">
				<h3 class="cen">{{title}}</h3>
				<!-- 操作按钮生成 -->
				<div class="content_edit">
					<div class="content_edit_item">
						<pre-btn-noexcel @button-event="select_method" :pre_control="control" />
					</div>
					<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
						<h3 class="red">
							{{sheet_flag}}
						</h3>
					</div>
				</div>

				<!-- 这里放主单据编辑内容-->
				<div class=" tab-row" v-for="(r,d) in max_row" :key="d">
					<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm" :key="index">
						<component :is="NextTickName(item.type)" :inData="checkJson(item)"
							@com-event="refresh_view_edit">
						</component>
					</div>
				</div>
				<!-- <div class="content_edit" v-show="file_show && show_FileMain">
				<div class="content_edit_item">
					<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
				</div>
			</div> -->

				<div v-show="show_detail" class="pre_leve_two">
					<!-- 这里放明细单据内容 -->
					<h5 class="cen pretop">{{title}}明细</h5>
					<!-- 明细部分编辑区 -->
					<div class="content_edit">
						<div class="content_btn_row">
							<div class="content_btn">
								<div class="content_btn_item">
									<button class="pre_btn_ok" @click="fun_d_load()">
										查询
									</button>
									<button class="pre_btn_ok" @click="d_data_clear()">
										清空
									</button>
									<button class="pre_btn_ok" @click="fun_d_save('_add')">
										保存
									</button>
									<button class="pre_btn_ok" @click="excelup()">
										导入
									</button>
									<button class="pre_btn_ok" @click="build_exceldata()">
										导出
									</button>
									<!-- <button class="pre_btn_ok" @click="build_exceldata()">
                  导出
                </button> -->
								</div>
							</div>
						</div>

						<div class="content_edit_item" v-for="(item,index) in d_parm" :key="index">
							<component :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_edit_d">
							</component>
						</div>

						<div class="content_edit_item" v-show="file_show && show_FileChildren">
							<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
						</div>
					</div>
					<!-- 明细部分展示区 -->
					<div id="pre_tab" class="pre_tab">
						<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
							<tr class="tab_header_new">
								<td v-for="(t,index) in d_name" :key="index">{{t.name}}</td>
								<td class="short0 cen">操作</td>
							</tr>
							<tr :id="'d_'+data_tr.row_num" v-for="data_tr in d_detail"
								@click="fun_d_upd('_edit',data_tr)">
								<!-- <td>{{data_tr.id}}</td> -->
								<td>{{data_tr.row_num}}</td>
								<td>{{data_tr.sheet_no}}</td>
								<td>{{data_tr.item_no}}</td>
								<td>{{data_tr.item_name}}</td>
								<td>{{data_tr.size}}</td>
								<td>{{data_tr.unit_name}}</td>
								<td>{{data_tr.qty_old}}
									<!-- <input style="width: 48px;" type="number" v-model="data_tr.qty"	@keyup.enter="fun_d_upd('_upd',data_tr)" /> -->
								</td>
								<td>{{data_tr.qty_new}}</td>
								<td>{{data_tr.qty}}</td>
								<td>{{data_tr.price}}</td>
								<td>{{data_tr.amount}}</td>
								<td>{{data_tr.note}}</td>
								<td>{{data_tr.u_name}}</td>
								<td>{{data_tr.sys_date}}</td>
								<td class="short0 cen">
									<!-- <button @click="fun_d_upd('_upd',data_tr)">保存</button> -->
									<button @click="fun_d_upd('_del',data_tr)">删除</button>
								</td>
							</tr>
						</table>
					</div>
				</div>




			</template>
		</pretan>

		<!-- 弹出向导层 end-->


		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in d_name" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="fun_d_load" :pre_th="d_parm" :api_url="d_sel_action"
			:api_action="d_upd_action" :api_method="'exp15'" :api_check="''" />

		<!-- 文件预览部分 -->
		<!-- 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefile" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="savefile" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>


	</div>
</template>

<script>
	/*


*/
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';


	export default {
		components: {
			"pre-button": () => import("../per_mode/pre_btn_control.vue"),
			"pre-btn-noexcel": () => import("../per_mode/pre_btn_tan.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue"),
			'per-exceldown': () => import("../auto/auto_excel_downDetail.vue"),
			'per-excelup': () => import("../auto/auto_excel_up.vue")
		},
		data() {
			return {
				element_loading: false,
				detail_data: [],

				max_row: 10,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				list_upfileall: [],

				pop_show: false,
				screenWidth: '',
				screenHeight: '',

				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				// excel
				show_excel: false,
				postjson1: {},

				show_detail: false,
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				f_name: "",

				//文件
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',


				show_book: false,
				show_table: true,

				redClass: 'red-row',
				blueClass: 'blue-row'

			};
		},
		activated() {
			console.log('激活');
		},
		mounted() {
			console.log('加载');
			this.load_data();
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}
			},
			refresh_view_edit: function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}

				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			refresh_view_edit_d: function(d, type) {
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == d.key) {
						if (this.d_parm[i].type == 'select' || this.d_parm[i].type == 'radio') {
							this.d_parm[i].val = d.val;
							this.d_parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.d_parm[i].val = d.val;
							break;
						}
						break;
					}
				}

				if (type == 'save') {
					this.fun_d_save('_add');
				}
			},
			check_is_pdf: function(res_url) {
				let is_pdf = false;
				if (/\.(pdf)$/.test(res_url.toLowerCase())) {
					is_pdf = true;
				}
				return is_pdf;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {
				// console.log(r);
				// 清理缓存
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.control = 'store_check';
				this.sel_action = 'exp_store_car_storecheck';
				this.api_url = api.http_method;
				this.upd_action = '_store_car_storecheck';
				this.title = '资产盘点';

				this.parm_sel = [{
						"name": "系统编号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "盘点仓库",
						"val": "",
						"key": "from_store",
						"type": "select",
						"class": "long2",
						"sel_action": "_base_storecar",
						"sel_name": "",
						"p": "1",
						"w": "1",
						"r": "0",
						"x": "1"
					}
				]

				this.parm = [{
						"name": "系统编号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1-2",
						"p": "1",
						"w": "0",
						"r": "1",
						"x": "1"
					},
					{
						"name": "盘点仓库",
						"val": "",
						"key": "check_store",
						"type": "select",
						"class": "long2",
						"sel_action": "_base_storecar",
						"sel_name": "",
						"p": "1",
						"w": "1",
						"r": "0",
						"x": "1"
					},
					{
						"name": "盘点日期",
						"val": "",
						"key": "check_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"w": "1",
						"r": "0",
						"x": "1"
					},
					{
						"name": "盘盈金额",
						"val": "",
						"key": "amount_in",
						"type": "number",
						"class": "long1",
						"p": "0",
						"w": "0",
						"r": "1",
						"x": "2"
					},
					{
						"name": "盘亏金额",
						"val": "",
						"key": "amount_out",
						"type": "number",
						"class": "long1",
						"p": "0",
						"w": "0",
						"r": "1",
						"x": "2"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					}
				];

				this.parm_th = [{
						"name": "序号"
					}, {
						"name": "单号"
					},
					{
						"name": "盘点仓库"
					},
					{
						"name": "盘点日期"
					},
					{
						"name": "盘盈金额"
					},
					{
						"name": "盘亏金额"
					},
					{
						"name": "备注"
					},
					{
						"name": "状态"
					},
					{
						"name": "修改人"
					},
					{
						"name": "修改时间"
					}
				]

				this.file_action = '';

				this.file_action = 'itembase';

				this.p1 = 'item';
				let date = new Date();
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				// var h = date.getHours();
				// h = h < 10 ? ('0' + h) : h;
				// var minute = date.getMinutes();
				// minute = minute < 10 ? ('0' + minute) : minute;
				// this.file_time = y + '' + m + '' + d + '' + h + '' + m;
				this.p2 = y + '' + m + '' + d;
				this.p3 = 'image';

				// 明细部分
				this.show_detail = true;
				this.d_sel_action = 'exp_store_car_storecheck_d';
				this.d_upd_action = 'store_car_d_storecheck';
				this.d_row_id = '';
				this.d_sys_date = '';
				this.d_parm = []; //明细参数构造；
				this.d_name = []; //明细标题

				this.d_parm = [{
						"name": "盘点单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "1"
					},
					{
						"name": "物品编码",
						"val": "",
						"key": "item_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "1",
						"r": "0"
					},
					{
						"name": "盘点数量",
						"val": "",
						"key": "qty",
						"type": "number",
						"class": "long1",
						"p": "1",
						"w": "1",
						"r": "0"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long2",
						"p": "1",
						"w": "0",
						"r": "0"
					}
				];

				this.d_name = [{
						"name": "序号"
					},
					{
						"name": "单号"
					},
					{
						"name": "编号"
					},
					{
						"name": "名称"
					},
					{
						"name": "规格"
					},
					{
						"name": "单位"
					},
					{
						"name": "仓库数量"
					},
					{
						"name": "盘点数量"
					},
					{
						"name": "差异数量"
					},
					{
						"name": "单价"
					},
					{
						"name": "差异金额"
					},
					{
						"name": "备注"
					},
					{
						"name": "修改人"
					},
					{
						"name": "更新时间"
					}
				];




				this.load_db_data();
			},
			select_method: function(type) {
				console.log('操作=' + type);

				switch (type) {
					case 'new':
						this.new_blank();
						break;
					case 'clear':
						this.data_clear();
						break;
					case 'add':
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.fun_upd('_del');
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_fileall();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				this.sys_date = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				this.d_detail = [];
				console.log('33333333');
				// console.log('===END============')
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, '', r);
				}, 200);
			},
			refresh_data: function(type, page, pagelength, backdata) {
				// console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载
				if (type == 'PAGE_LENGTH_CHANGE' || type == 'PAGE_NOW' || typeof(type) === 'undefined') {
					this.nowpage = page;
					this.page_length = pagelength;
					this.load_db_data();
					return;
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}

				let back = null;
				if (type == 'UPDATE_OK' && typeof(backdata) != "undefined" && backdata != '') {
					// 更新编辑信息
					this.nowpage = page;
					this.load_db_data();

					back = JSON.parse(backdata);
					// console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					// console.log('sheet_flag==' + this.sheet_flag + ' close=' + this.sheet_flag.indexOf('删除成功'))
					if (this.sheet_flag.indexOf('提交成功') >= 0) {
						this.show_btn = false;
					} else {
						this.show_btn = true;
					}

					if (this.sheet_flag.indexOf('删除成功') >= 0) {
						this.closeshow();
						return;
					}



				}

				// 刷新住单据信息
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
						'', '', '',
						'', '', '', '', '', r)
				).then(res => {
					res = JSON.parse(res);

					this.element_loading = false;
					let res_page = [];
					res_page = res[0][0];

					if (res_page.flag == 1) {
						let bd = [];
						// console.log('allcount='+res_page.all_count)
						if (res_page.all_count > 0) {
							let t_list_data = res[1];
							// console.log(t_list_data);
							for (let i = 0; i < t_list_data.length; i++) {
								let arr = [];
								for (let j in t_list_data[i]) {
									let o = {};
									o.key = j;
									let temp_str = '';
									temp_str = t_list_data[i][j];
									if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") > 0) {
										temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
										temp_str = ReplaceAll(temp_str, '\n', "<br/>");
										temp_str = temp_str.replace("\\r\\n", "\r\n");
										temp_str = temp_str.replace("\\n", "\n");
									}
									o.val = temp_str;
									arr.push(o);
								}
								bd.push(arr);
							}
							this.sel_row(bd[0], 'edit');

							if (this.show_detail) {
								this.fun_d_load();
							}
						}

					} else {
						this.$message({
							message: '编辑数据更新失败! \r\n ' + res.data.msg,
							type: 'success'
						});
					}

				});

				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新
			},
			sel_row: function(item, type) {
				// console.log('选择', item);
				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
							//	根据需要设置
						case 'name':
							this.title = item[i].val;
							break;
						case 'img_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = BackSpecial(item[i].val);
							break;
						case 'file_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				if (typeof(this.file_name) == 'undefined' || this.file_name == '') {
					this.file_show = false;
				} else {
					this.file_show = true;
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = item[i].val;
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}



				// console.log(this.parm);
				switch (type) {
					case 'edit': // 切换背景色
						this.$refs.file_table.setCurrentRowJsonOld('m_', item[1].val);
						break;
					case 'show': // 打开编辑页面
						this.$refs.mypop.showpop();

						if (this.show_detail) {
							this.fun_d_load();
						}
						break;
					case 'del': // 执行删除
						this.fun_upd('_del');
						break;
					default:
						break;
				}



			},
			new_blank: async function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;

				await this.data_clear();

				this.$refs.mypop.showpop();

			},
			closeshow: function() {
				console.log('关闭');
				this.$refs.mypop.closeshow();
			},
			fun_del: function(d) {
				this.sel_row(d, 'del');
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd' || type == '_del') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_del') {
					this.fun_del_fileall();
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].w == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {

						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.parm[i].val));
						} else if (this.parm[i].type == 'textarea') {
							// console.log(this.parm[i].val);
							let str = '';
							str = this.parm[i].val;
							// let str = this.parm[i].val;
							str = str.replace(/\n/g, '<br/>');
							str = str.replace(/\s/g, '&nbsp;');
							d.push(str);
						} else {
							// console.log(this.parm[i].val);
							d.push(this.parm[i].val);
						}
					}
				}

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_Common(this.upd_action + type, this.row_id, this.sys_date, d, r);


			},
			load_upAllFile: function(p1, p2) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					// exp_getfilesrc_item_base 查询所有文件路径
					that.$post(
						api.http_method, Sel_page_and_length('exp_getfilesrc_item_base', 1, 100, p1, p2)
					).then(res => {

						res = JSON.parse(res);
						// console.log(res);
						resolve(res[0])
					});

				});
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},

			/****明细部分操作 start***********************************************/
			d_data_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}
			},
			fun_d_upd: function(type, item) {
				// console.log('编辑');
				console.log(item);
				this.d_row_id = item.id;
				this.d_sys_date = item.sys_date;

				for (let j = 0; j < this.d_parm.length; j++) {
					for (let d in item) {
						if (this.d_parm[j].key == d) {
							// console.log(d + '=' + item[d]);
							this.d_parm[j].val = item[d];

							break;
						}
					}
				}

				// for (var i = 0; i < this.d_detail.length; i++) {
				//   if (this.d_detail[i].row_num == item.row_num) {
				//     document.getElementById('d_' + item.row_num).style.background = '#92a4f3';
				//   } else {
				//     if (this.d_detail[i].row_num % 2 == 0) {
				//       document.getElementById('d_' + this.d_detail[i].row_num).style.background = '#fff';
				//     } else {
				//       document.getElementById('d_' + this.d_detail[i].row_num).style.background = '#f5f5f5';
				//     }
				//   }
				// }

				this.fun_chage();

				switch (type) {
					case '_del':
						this.fun_d_save('_del');
						break;
					case '_upd':
						this.fun_d_save('_upd');
						break;
				}

			},
			fun_d_load: function() {

				this.d_detail = [];

				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
				).then(res => {
					this.element_loading = false;

					res = JSON.parse(res);
					// console.log('明细返回', res);
					if (res.length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.d_detail.push(t[i]);
						}
						// console.log(this.d_detail);

						let that = this;
						setTimeout(() => {
							that.fun_chage();
						}, 200)
						// for (let i = 0; i < this.d_detail.length; i++) {
						//   console.log(this.d_detail[i]);
						//   let temp_id = 'd_' + this.d_detail[i].row_num;
						//   let qty = this.d_detail[i].qty;
						//   let temp_css = '';
						//   if (Number(qty) < 0) {
						//     temp_css = 'background-color: #ff0000 !important;';
						//     document.getElementById(temp_id).style.cssText = temp_css;
						//   }

						//   if (Number(qty) > 0) {
						//     temp_css = 'background-color: #0000ff !important;';
						//     document.getElementById(temp_id).style.cssText = temp_css;
						//   }

						// }



					} else {
						this.$message({
							message: "没有查询到明细",
							type: 'success'
						});
					}
				});
			},
			fun_chage: function() {
				// 样式设定
				for (let i = 0; i < this.d_detail.length; i++) {
					// console.log(this.d_detail[i]);
					let temp_id = 'd_' + this.d_detail[i].row_num;
					let qty = this.d_detail[i].qty;
					let temp_css = '';
					if (Number(qty) < 0) {
						temp_css = 'background-color: #f7e3a8 !important;';
						document.getElementById(temp_id).style.cssText = temp_css;
					}

					if (Number(qty) > 0) {
						temp_css = 'background-color: #f2c7b2 !important;';
						document.getElementById(temp_id).style.cssText = temp_css;
					}

				}
			},
			fun_d_save: async function(type) {
				if (Number(this.d_row_id) == 0) {
					for (let i = 0; i < this.d_parm.length; i++) {
						switch (this.d_parm[i].key) {
							case 'id':
								this.d_row_id = this.d_parm[i].val;
								break;
							case 'sys_date':
								this.d_sys_date = this.d_parm[i].val;
								break;
							case 'sheet_no':
								if (this.d_parm[i].val == '') {
									this.d_parm[i].val = this.sheet_no;
								}
								break;
							default:
								break;
						}
					}
				}

				let d = [];
				// d.push(this.sheet_no); //保存主单据
				for (let i = 0; i < this.d_parm.length; i++) {

					if (this.d_parm[i].p == '1') {
						if (this.d_parm[i].type == 'time' || this.d_parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.d_parm[i].val));
						} else {
							d.push(this.d_parm[i].val);
						}
					}
				}

				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].p == '1' && this.d_parm[i].w == '1') {
						if (this.d_parm[i].val == '') {
							this.$message({
								message: this.d_parm[i].name + ' 是必填项,请填写!',
								type: 'success'
							});
							return
						}
						break;
					}
				}

				// console.log('d_row_id=' + this.d_row_id);
				let temp_data = '';
				temp_data = Method_Common('_' + this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							this.d_row_id = res.data.parm.id;
							this.d_sys_date = res.data.parm.sys_date;

							// document.getElementById('isfirst').focus();
							let that = this;
							setTimeout(function() {
								that.refresh_data();
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},
			excelup: function() {
				console.log('上传。。。');
				if (this.sheet_no == '') {
					this.$message({
						message: ' 主单号不能为空,请先选择盘点仓库并且保存!',
						type: 'warning'
					});
					return
				}

				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			build_exceldata: function(type) {
				if (type == 'close') {
					this.show_excel = false;
				} else {

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
					});

					this.show_excel = true;
				}
			},
			/****明细部分操作 end***********************************************/
			///////////////////////////////////////////////////////
			edit_mode: function() {

				this.$refs.itemmode.showpop();
			},

			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						message: '操作不正确1,请选择要上传附件的具体分类信息!',
						type: 'warning'
					});
					return;
				}
				console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确2,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

				let fileobj = document.getElementById('savefile');
				fileobj.click();
			},
			fun_look_file: async function(item) {
				console.log('点击预览附件');
				if (typeof(item) !== 'undefined' && item != '') {
					await this.sel_row(item);
				}

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					var pdfview = document.getElementById('loodlink');
					pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					pdfview.click();

				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('savefile');
				// console.log('点击选择结果');
				console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 5000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];

					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					this.file_size = size;

					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过5M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					this.file_show = true;

				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_fileall: async function() {
				this.list_upfileall = [];
				this.list_upfileall = await this.load_upAllFile(this.row_id);
				console.log(this.list_upfileall)
				if (typeof(this.list_upfileall) !== 'undefined') {
					for (let i = 0; i < this.list_upfileall.length; i++) {
						if (this.list_upfileall[i].f_src != '') {
							await this.fun_del_file(this.list_upfileall[i]);
						}
					}
					this.load_db_data();
				}
			},
			fun_del_file: function(item) {
				console.log(item);
				var postdata = "";
				postdata =
					'{"action":"' + 'file_del_upfile' + this.file_action + '","user_no":"' +
					item.sign_no +
					'","upfile_path":"' +
					base_encode(item.file_src) +
					'","sheet_no":"' +
					'' +
					'","rowid":"' +
					item.id +
					'","sys_date":"' +
					item.sys_date +
					'"}';

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						// console.log(res);
						res = JSON.parse(res);
						resolve(res.data)
					});

				});



			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// console.log('文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// console.log('上传长度=' + temp_data.size);
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(this.file_name) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';
				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				console.log('p3=' + this.p3);
				this.element_loading = true;

				var postdata = "";
				postdata =
					'{"action":"data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","f_name":"' +
					DeleteSpecialWord(this.file_name) +
					'","f_type":"' +
					this.file_type +
					'","f_size":"' +
					this.file_size +
					'","f_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","mode_type":"' +
					this.mode_type +
					'","mode_name":"' +
					this.mode_name +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.load_db_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.td-image {
		cursor: pointer;
	}

	.pre-input {
		display: inline-block;
		vertical-align: middle;
		width: 128px;
	}

	.red-row {
		background-color: #ff0000 !important;
	}

	.blue-row {
		background-color: #0000ff !important;
	}
</style>